//Node Modules
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Auth } from "aws-amplify";
import { useRecoilState, useSetRecoilState } from "recoil";

//BinaryForge Components
import { Note } from "../../helpers";
import { UserSetupMFA } from "./";

//3rd Party Components
import { InputSwitch } from "primereact";
import { confirmDialog } from "primereact/confirmdialog";

//Atoms
import { dialogAtomFamily } from "../../../atoms/dialog";
import { toastAtom } from "../../../atoms/toast";

//Helpers

const UserProfileMFA = ({ currentUser }) => {
	// Hooks
	const { t } = useTranslation();

	//Recoil State
	const setShowMfaSetup = useSetRecoilState(dialogAtomFamily("userSetupMfaDialog"));
	const [toast, setToast] = useRecoilState(toastAtom);

	// Local State
	const [enabled, setEnabled] = useState(
		currentUser.cognitoUser.preferredMFA === "SOFTWARE_TOKEN_MFA" ? true : false
	);

	const handleEnableMfa = (state) => {
		setEnabled(state);
		if (state) {
			setShowMfaSetup(true);
		} else {
			confirmDialog({
				header: t("profile.mfa.dialog.remove.header"),
				message: (
					<Note
						messageKey={t("profile.mfa.dialog.remove.message")}
						icon="pi pi-exclamation-triangle fontColour-warn"
					/>
				),
				acceptLabel: t("profile.mfa.dialog.remove.disable"),
				rejectLabel: t("profile.mfa.dialog.remove.keep"),
				acceptIcon: "pi pi-lock-open",
				acceptClassName: "error feature",
				rejectClassName: "success",
				accept: () => doDisableMfa(),
				reject: () => {}, //Do Nothing,
			});
		}
	};

	const doDisableMfa = async () => {
		try {
			await Auth.setPreferredMFA(currentUser.cognitoUser, "NOMFA");
			setToast({
				...toast,
				severity: "success",
				summary: t("profile.mfa.dialog.remove.toast.successSummary"),
				detail: t("profile.mfa.dialog.remove.toast.successDetail"),
			});
		} catch (err) {
			console.error("Disable MFA Error ::", err);
			setToast({
				...toast,
				severity: "error",
				summary: t("profile.mfa.dialog.remove.toast.errorSummary"),
				detail: t("profile.mfa.dialog.remove.toast.errorDetail", { error: err.message }),
			});
		}
	};

	const handleResteMfaState = () => {
		setEnabled(currentUser.cognitoUser.preferredMFA === "SOFTWARE_TOKEN_MFA" ? true : false);
	};

	return (
		<section>
			<div className="card">
				<header>
					<h3>{t("profile.mfa.title")}</h3>
				</header>
				<div className="flex aItems-center gap-medium marginBottom-small">
					<span className="label">{t("profile.mfa.enable")}:</span>
					<InputSwitch checked={enabled} onChange={(e) => handleEnableMfa(e.value)} />
				</div>
				<Note
					messageKey={t("profile.mfa.message")}
					icon="pi-info-circle fontColour-info"
					messageStyle="font-light fontSize-small"
				/>

				<UserSetupMFA currentUser={currentUser.cognitoUser} updateStateOnClose={handleResteMfaState} />
			</div>
		</section>
	);
};

export default UserProfileMFA;
